module.exports = __webpack_public_path__ + "img/team-v02.c7512a07.png";